module.exports = __webpack_public_path__ + "static/img/15bg_4.766dc1f.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/15bg_4.png
// module id = 653
// module chunks = 1